export default "__VITE_ASSET__D01tEbfV__"